<div class="form-container" [ngClass]="horizontalMode? 'horizontal-form' : 'default-form'">
    <kendo-pdf-export [ngClass]="{'print-mode': printMode}" #pdf margin="2cm">
        <h2 *ngIf="printMode"> {{title}} </h2>
        <form role="form" [ngClass]="{'disabled-form': !isEditMode}" class="form" novalidate [formGroup]="form">
            <formly-form class="formly-form" [options]="options" [model]="model"
                [fields]="formResult?.configuration?.fields" [form]="form">
            </formly-form>
        </form>
    </kendo-pdf-export>
</div>